import "./index.less";
import RefreshIcon from "@/assets/common/ic_refresh.svg?react";
import SuccessIcon from "@/assets/common/ic_success_gray.svg?react";
// import DeleteIcon from "@/assets/common/ic_delete.svg";
import CopyIcon from "@/assets/common/ic_copy.svg?react";
import GoodIcon from "@/assets/common/ic_good.svg?react";
import BadIcon from "@/assets/common/ic_bad.svg?react";
import GoodActiveIcon from "@/assets/common/ic_good_active.svg?react";
import BadActiveIcon from "@/assets/common/ic_bad_active.svg?react";
import { ChatMessage, FeedBackType } from "@/services/api_question";
import ChatStore from "@/store/chat.store";
import { message as MessageTip } from "antd";
import { useState } from "react";
import fridayReporter from "@/utils/friday";

interface AITipToolProps {
  message: ChatMessage;
  showRegenrate?: boolean;
}

const AITipTool = (props: AITipToolProps) => {
  const { message, showRegenrate } = props;
  const messageList = ChatStore((state) => state.messageList);

  const [hasCopy, setHasCopy] = useState(false);

  const handleRegenerate = () => {
    ChatStore.getState().regenerateChat(message.id);
    fridayReporter.pushData({
      eventCode: 'SummaryPage_AI_Regenerate'
    })
  };

  const handleFeedBack = (feedbackType: FeedBackType) => {
    const newMessage = {
      ...message,
      feedbackType,
    };
    if(feedbackType === "GOOD" || feedbackType === "BAD"){
      fridayReporter.pushData({
        eventCode: feedbackType === "GOOD" ? 'SummaryPage_AI_Like' : 'SummaryPage_AI_Unlike'
      })
    }
    const index = messageList.findIndex((item) => item.id === message.id);
    messageList[index] = newMessage;
    ChatStore.getState().setMessageList([...messageList]);
    ChatStore.getState().feedBackAnswer({
      messageId: message.id,
      feedbackType,
    });
  };

  return (
    <div className="AITipTool">
      {showRegenrate && (
        <div className="tool-item" onClick={handleRegenerate}>
          <RefreshIcon />
          <div className="text">重新生成</div>
        </div>
      )}
      {/* <div className="tool-item">
        <DeleteIcon />
      </div> */}
      {hasCopy ? (
        <div className="tool-item">
          <SuccessIcon />
        </div>
      ) : (
        <div
          className="tool-item"
          onClick={() => {
            fridayReporter.pushData({
              eventCode: 'SummaryPage_AI_Copy'
            })
            navigator?.clipboard?.writeText(message.message);
            setHasCopy(true);
            MessageTip.success("复制成功");
            setTimeout(() => {
              setHasCopy(false);
            }, 2 * 1000);
          }}
        >
          <CopyIcon />
        </div>
      )}

      <div
        className="tool-item"
        onClick={() => {
          message.feedbackType === "GOOD" ? handleFeedBack("NONE") : handleFeedBack("GOOD");
        }}
      >
        {message.feedbackType === "GOOD" ? <GoodActiveIcon /> : <GoodIcon />}
      </div>
      <div
        className="tool-item"
        onClick={() => {
          message.feedbackType === "BAD" ? handleFeedBack("NONE") : handleFeedBack("BAD");
        }}
      >
        {message.feedbackType === "BAD" ? <BadActiveIcon /> : <BadIcon />}
      </div>
    </div>
  );
};

export default AITipTool;
